// src/lib/persistStep.js

// Load a JSON object from localStorage. If missing/broken, return fallback/null.
export function loadProgress(key, fallback = null) {
  try {
    if (typeof window === "undefined" || !window.localStorage) return fallback;
    const raw = window.localStorage.getItem(key);
    return raw ? JSON.parse(raw) : fallback;
  } catch {
    return fallback;
  }
}

// Save a JSON-serializable object to localStorage (best-effort).
export function saveProgress(key, value) {
  try {
    if (typeof window === "undefined" || !window.localStorage) return;
    window.localStorage.setItem(key, JSON.stringify(value));
  } catch {
    // ignore quota/serialization errors
  }
}

// Remove a persisted progress payload from localStorage (best-effort).
export function clearProgress(key) {
  try {
    if (typeof window === "undefined" || !window.localStorage) return;
    window.localStorage.removeItem(key);
  } catch {
    // ignore storage failures
  }
}
